import isEmpty from "lodash/isEmpty";
import { useGrowlStore, useGrowlStoreActions } from "PFApp/stores/growl_store";
import { Growl } from "PFComponents/growl";

import css from "./growls.module.scss";

export type { GrowlEntry } from "PFApp/stores/growl_store";

export const Growls = (): React.ReactElement | null => {
  const growls = useGrowlStore((state) => state.growls);
  const { hideGrowl } = useGrowlStoreActions();

  if (isEmpty(growls)) {
    return null;
  }

  return (
    <div className={css.root}>
      {(growls || []).map((growl) => (
        <Growl {...growl} key={growl.timestamp} onClose={() => hideGrowl(growl.id)} />
      ))}
    </div>
  );
};
